// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9089":"9cac770b","9802":"0462bf25"}[chunkId] + ".chunk.css";
};